import './top_banner_vendor_two.css'

export const Top_Banner_Vendor_Two=(props)=>{
    // alert(JSON.stringify(props));
    return(
        <div class="hospital-banner54641">
            {props.landingVendor.length>0?
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="hospital-name-container">
                        <i class="hospital-name-icon fas fa-hospital"></i>
                        <h1 class="hospital-name">{props.landingVendor[0]["company_name"]}</h1>
                    </div>
                    
                    <p class="hospital-tagline">
                        We are committed to delivering accurate, reliable, and timely diagnostic solutions to empower better health decisions. 
                        Our state-of-the-art pathology lab connects customers with advanced testing services, ensuring precise results 
                        with the highest standards of quality and care.
                    </p>
                    
                    <div class="hospital-info">
                        <div class="info-item">
                            <div class="info-icon"><i class="fa fa-address-card-o"></i></div>
                            <div class="info-text">
                                {props.landingVendor[0]["d_address"]}
                                {/* AH/31, Senior HIG, Pandit Dindayal Upadhyay Nagar, Sukhliya, Indore, Madhya Pradesh 452010 */}
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon"><i class="fa fa-envelope"></i></div>
                            <div class="info-text">
                                care@advaiet.com
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-icon"><i class="fa fa-phone"></i></div>
                            <div class="info-text">
                                +91 89-89-456-456
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>:''}
    </div>
    );
}

export default Top_Banner_Vendor_Two